import React from "react";
import { observable, action } from "mobx";
import GoogleBtnImg from "Assets/Settings/googleWhite.png";
import MicrosoftBtnImg from "Assets/Settings/microsoft.png";
import { observer } from "mobx-react";

class GmailMessagePopupState {
  @observable showPopup = false;
  @observable connectBtnAction = () => {};
  @observable popupValues = {
    title: "",
    subTitle: ""
  };

  @action
  setShowPopup = val => {
    this.showPopup = val;
    if (val) {
      document.getElementsByTagName("body")[0].classList.add("scrollHidden");
    } else {
      this.popupValues = this.defaultPopupValue;
      document.getElementsByTagName("body")[0].classList.remove("scrollHidden");
    }
  };

  @action
  setConnectBtnAction = val => {
    this.connectBtnAction = val;
  };

  @action
  setPopupValues = val => {
    this.popupValues = val;
  };
}

const gmailMessagePopupState = new GmailMessagePopupState();

// 409 — inbox already connected to a different Salesgear account. Same popup for
// every provider; only Google carries the Gmail-specific help link.
const GMAIL_409_HELP_LINK = `<a class="errorLink" href="https://support.salesgear.io/en/articles/5660382-why-do-i-get-the-connection-failed-error-when-i-try-to-connect-my-gmail-with-salesgear" target="_blank" rel="noopener noreferrer"><span>Why do I get the connection failed error?</span><i class="fa fa-external-link openInNewTabIcon" aria-hidden="true"></i></a>`;
const showAlreadyConnectedPopup = (provider = "Google") => {
  gmailMessagePopupState.setPopupValues({
    title: "Connection Failed",
    provider,
    subTitle: `Unable to connect your ${provider} account with Salesgear as its already connected to a different Salesgear account. Please try re-connecting a different ${provider} account`,
    ...(provider === "Google" ? { additionalLink: GMAIL_409_HELP_LINK } : {})
  });
  gmailMessagePopupState.setShowPopup(true);
};

const GmailMessagePopup = observer(() => {
  const {
    subTitle = "",
    title = "",
    additionalLink = "",
    provider = "Google"
  } = gmailMessagePopupState?.popupValues || {};
  const isGoogle = provider === "Google";

  const PopupHeader = () => {
    return (
      <section className="popupHeader">
        <div className="title">
          {subTitle && (
            <i className="material-icons errorIcon">error_outline</i>
          )}
          {title}
        </div>
        <i
          className="material-icons closeIcon"
          onClick={() => gmailMessagePopupState?.setShowPopup(false)}
        >
          close
        </i>
        {subTitle && (
          <div
            className="subTitle"
            dangerouslySetInnerHTML={{ __html: subTitle }}
          />
        )}
        {additionalLink && (
          <div
            className="additionalLink"
            dangerouslySetInnerHTML={{ __html: additionalLink }}
          />
        )}
      </section>
    );
  };

  const PopupBody = () => {
    return (
      <div className="popupBody">
        <video
          style={{ width: "100%", height: "100%" }}
          preload="auto"
          muted={true}
          loop={true}
          autoPlay={true}
          poster="http://cdn.salesgear.io/images/poster/gmail_oauth_steps_poster.png"
          src="https://cdn.salesgear.io/videos/gmail_ouath_steps.mp4"
        />
      </div>
    );
  };

  const ConnectCTA = () => {
    return (
      <div className="popupFooter">
        <img
          id={isGoogle ? "googleAuthBtn" : "outlookAuthBtn"}
          className={isGoogle ? "googleAuthBtn" : "outlookAuthBtn"}
          src={isGoogle ? GoogleBtnImg : MicrosoftBtnImg}
          alt={isGoogle ? "Sign in with Google" : "Sign in with Microsoft"}
          onClick={gmailMessagePopupState?.connectBtnAction}
        />
      </div>
    );
  };

  return gmailMessagePopupState?.showPopup ? (
    <>
      <div className="gmailMessagePopup">
        <div
          className={`gmailMessagePopupCont animated customzoomIn ${
            isGoogle
              ? subTitle?.length > 0
                ? "grid-row-4"
                : "grid-row-3"
              : "connFailedSimple"
          }`}
        >
          <PopupHeader />
          {/* <PopupBody /> */}
          <ConnectCTA />
        </div>
      </div>
      <div className="popupMask"></div>
    </>
  ) : (
    ""
  );
});

export default GmailMessagePopup;
export { GmailMessagePopup, gmailMessagePopupState, showAlreadyConnectedPopup };
